// Composition Function to track window dimension

import { reactive, onMounted, onUnmounted, readonly, Ref, watch } from 'vue';
import { Dimension } from 'reactive-graphics';
import { BehaviorSubject } from 'rxjs';

export const useCanvasDimension = (canvas: Ref<HTMLCanvasElement>) => {

    const dimension: Dimension = reactive({ width: 0, height: 0 });
    const dimensionSubject: BehaviorSubject<Dimension> = new BehaviorSubject({ width: 0, height: 0 });

    const computeCanvasDimension = () => {
        const style = window.getComputedStyle(canvas.value);
        const computedWidth = +style.width.split("px")[0];
        const computedHeight = +style.height.split("px")[0];
        // console.log(`computed style: ${computedWidth}, ${computedHeight}. Canvas dim: ${canvas.value.width}, ${canvas.value.height}.`);
        canvas.value.width = computedWidth;
        canvas.value.height = computedHeight;
        // se emite dimensión del canvas
        dimension.width = computedWidth;
        dimension.height = computedHeight;
        dimensionSubject.next({ width: computedWidth, height: computedHeight });
    };

    onMounted(() => {
        computeCanvasDimension();
        window.addEventListener("resize", computeCanvasDimension);
    });
    onUnmounted(() => {
        console.log('++onUnmunted()')
        window.removeEventListener("resize", computeCanvasDimension);
    });
    
    return { dimension: readonly(dimension), dimension$: dimensionSubject.asObservable() };
}
